import { IEntity } from "./Entity";

export interface IPPAppEvidence extends IEntity {
    FileUniqueID?: string;
    Details?: string;
    ProjectID?: number;
    DateCreated?: Date;
    AddedByUserID?: number;
    AttachmentType?: string;
}

export class PPAppEvidence implements IPPAppEvidence {
    public ID: number = 0;
    public Title: string = null;
    public FileUniqueID?: string = null;
    public Details?: string = "";
    public ProjectID?: number = null;
    public DateCreated?: Date = null;
    public AddedByUserID?: number = null;
    public AttachmentType?: string = null;

    constructor(
        projectID: number,
        attachmentType: string
    ) {
        this.ProjectID = projectID;
        this.AttachmentType = attachmentType;
    }
}